import { gql } from "@apollo/client"

const DELETE_ASSET_MUTATION = gql`
  mutation deleteAsset($input: DeleteAssetInput!) {
    deleteAsset(input: $input) {
      id
      filename
      type {
        id
        type
      }
    }
  }
`

export default DELETE_ASSET_MUTATION